module.exports = __webpack_public_path__ + "img/Butterfly_00155.7db60f3d.png";